// extracted by mini-css-extract-plugin
var _1 = "Annotation-module__active--RAKmF";
var _2 = "Annotation-module__animateUploadProgressBarWidth--IM9mp";
var _3 = "Annotation-module__animatedBackground--hfj_E";
var _4 = "Annotation-module__annotationLinkContainer--gUE38";
var _5 = "Annotation-module__compactAnnotationIconContainer--CaBFg";
var _6 = "Annotation-module__createContainer--K2HkV";
var _7 = "Annotation-module__fullIconContainer--tL7g1";
var _8 = "Annotation-module__icon--OBpTu";
var _9 = "Annotation-module__innerFullViewContainer--WdcnZ";
var _a = "Annotation-module__overflowMenuContainer--_VvAk";
var _b = "Annotation-module__popoverLinkInputContainer--lXqCc";
var _c = "Annotation-module__preview--a4QQ1";
var _d = "Annotation-module__previewContainer--KcyEP";
var _e = "Annotation-module__ring--WJhvv";
export { _1 as "active", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "annotationLinkContainer", _5 as "compactAnnotationIconContainer", _6 as "createContainer", _7 as "fullIconContainer", _8 as "icon", _9 as "innerFullViewContainer", _a as "overflowMenuContainer", _b as "popoverLinkInputContainer", _c as "preview", _d as "previewContainer", _e as "ring" }
